import type { IgnorableFn } from '~~/layers/datadog/app/composables/datadog'

export const DATADOG_IGNORABLE: IgnorableFn[] = [
  (_, _message, error: any) => {
    const errorPaths = ['cause.message', 'causes.stack', 'causes[0].message']

    const errorRegexes = [
      /AsyncData request cancelled by deduplication/i,
      /Fetch is aborted/i,
    ]

    return errorPaths.some((path) => {
      const property = R_prop(error, ...(R_stringToPath(path) as [string]))
      if (!property) return false
      return errorRegexes.some((regex) => regex.test(property))
    })
  },
  (_, message) => message.includes('zoid destroyed all components'),
  (_, message) => /csp_violation/i.test(message),
  (_, message) => /evaluating 'a\.L'/i.test(message),
  (_, message) => /refused to/i.test(message),
]

export const DATADOG_STATES = {
  Player: 'datadog_player',
} as const
